import { httpService } from "../httpService.service";

// Backend contract — F-11 Audit trail (paged). System Admin / PM.
// Item: { id, timestamp, userId, userFullName, entityType, entityId,
//   action: 1=Created|2=Updated|3=Deleted, fieldName, oldValue, newValue,
//   isAiGenerated, projectId, contractId }.
export const getAuditTrail = (
  { entityId, projectId, action, isAiGenerated, pageNumber = 1, pageSize = 20 } = {},
  callback,
  errCallback
) => {
  const params = new URLSearchParams();
  if (entityId) params.append("EntityId", entityId);
  if (projectId) params.append("ProjectId", projectId);
  if (action !== undefined && action !== null && action !== "")
    params.append("Action", action);
  if (isAiGenerated !== undefined && isAiGenerated !== null && isAiGenerated !== "")
    params.append("IsAiGenerated", isAiGenerated);
  params.append("pageNumber", pageNumber);
  params.append("pageSize", pageSize);
  return httpService.get(
    `/api/Audit/getAuditTrail?${params.toString()}`,
    callback,
    errCallback
  );
};

// Audit action codes.
export const AuditAction = {
  1: "Created",
  2: "Updated",
  3: "Deleted",
};
